<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
             <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-5.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z9-ytj.png) center center no-repeat;background-size:400%,100%,cover;">
                </div>
            </div> -->
            <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">

            <!--解决方案-->
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">应急行业解决方案</span> <span
                    class="db f20  lp2 mt10 ph-col-gr">Emergency Industry Solutions</span> </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">行业痛点</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">专业人才短缺</span></strong><br>
                    当应急管理涉及多个专业领域，如自然灾害防治、事故灾难救援，需要大量具备专业知识和技能的人才。</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">监测手段有限</span></strong><br>
                    在对突发事件的监测方面，部分应急部门的监测设备和技术相对落后，无法及时、准确地获取相关信息。</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">技术整合困难</span></strong><br>
                    预测过程中涉及到多种技术，将这些技术有效地整合在一起，形成一个高效、稳定的预测系统，需要较高的技术水平和协调能力。</p>
            </div>
            <!--解决方案end-->

            <!--产品-->
            <div class="ph-sthz clearfloat ov mt20">
                <div class="w100 tc mt20 white"> <span class="db f40 fb lp2 mt40">方案架构</span> <span
                        class="db f20  lp2 mt10 ">Solution Architecture</span> </div>
                <div class="ph-jcrj jz mt30 ov">
                    <div class="ph-jcrj-a jz mt50"><img src="../../assets/mobile/images/icq14.png" width="100%"
                            alt="" /></div>
                </div>
            </div>

            <!--产品end-->
        </div>
        <!--内容大框end-->
        <div class="w100 lh40 tc mt20"> <span class="db f40 fb lp2 mt20">应用场景</span> <span
                class="db f20  lp2 mt10 ph-col-gr">Application Scenario</span> </div>
        <div class="ph-yycjdi jz mt20 ov">
            <ul class="w100">
                <li class="ov"> <img src="../../assets/mobile/images/ying-1.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">01</div>
                        <div class="ph-col-gr5 f16 tc fb">极端天气识别</div>
                        <div class="white f16 tc pt40">实时识别出当下的天气情况</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">02</div>
                        <div class="ph-col-gr5 f16 tc fb">人员聚集识别</div>
                        <div class="white f16 tc pt40">实时统计视频区域内人数</div>
                    </div>
                    <img src="../../assets/mobile/images/ying-2.jpg" width="100%" height="100%" alt="" />
                </li>
                <li class="ov"><img src="../../assets/mobile/images/ying-3.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">03</div>
                        <div class="ph-col-gr5 f16 tc fb">火灾识别</div>
                        <div class="white f16 tc pt40">结合场景智能识别</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">04</div>
                        <div class="ph-col-gr5 f16 tc fb">内涝积水识别</div>
                        <div class="white f16 tc pt40">可按积水程度智能识别</div>
                    </div>
                    <img src="../../assets/mobile/images/ying-4.jpg" width="100%" height="100%" alt="" />
                </li>
                <li class="ov"><img src="../../assets/mobile/images/ying-5.jpg" width="100%" height="100%" alt="" />
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">05</div>
                        <div class="ph-col-gr5 f16 tc fb">别道决口识别</div>
                        <div class="white f16 tc pt40">河道溃堤、决口识别</div>
                    </div>
                </li>
                <li class="ov">
                    <div class="ph-rig-box">
                        <div class="ph-col-gr4 f36 mt30 pl30">06</div>
                        <div class="ph-col-gr5 f16 tc fb">山体滑坡识别</div>
                        <div class="white f16 tc pt40">落石、山体滑坡场景识别</div>
                    </div>
                    <img src="../../assets/mobile/images/ying-6.jpg" width="100%" height="100%" alt="" />
                </li>
            </ul>
        </div>
        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"><span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-5.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z9-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>